import React from 'react';

import {textCaptionStyles} from './ui-controls/Text';

const OpenURLButton = ({url, children}) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      style={{...textCaptionStyles, lineHeight: 0}}>
      {children}
    </a>
  );
};

export default OpenURLButton;
